import React from "react";
import "./Lifting_Buildings.css";
import { Link } from "react-router-dom";
import ContactSection2 from "./ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function Transportation_of_protective_equipment_and_mobile_safe_room() {
  return (
    <div className="Lifting_Buildings-page">

      {/* =====================================================
          HERO
      ===================================================== */}

      <div className="Lifting_Buildings-hero">
        <div className="Lifting_Buildings-overlay">
          <h1>הובלת מיגונית וממ"ד</h1>
        </div>
      </div>


      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              הובלת מיגונית וממ"ד עם נצר הובלות ומנופים
            </div>

            <div className="building-video-wrapper">

              <video
                className="building-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                playsInline
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src="/video/10.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.
              </video>

            </div>

            <p className="building-video-caption">
              צפו בסרטון והכירו את שירותי הובלת המיגוניות והממ"דים
            </p>

          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">
            הובלת מיגונית וממ"ד נייד דורשת תכנון מקצועי,
            ציוד מתאים וניסיון בעבודה עם יחידות כבדות.
            נצר הובלות ומנופים מספקת פתרונות הובלה והרמה
            בהתאם למידות היחידה, למשקלה ולתנאי השטח.
          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">

              <img
                src="/images/41.jpeg"
                alt="הובלת מיגונית וממ״ד"
              />

            </div>


            <div className="text-box">

              <p>
                לפני הובלת מיגונית או ממ"ד נייד חשוב לבדוק
                את נקודת האיסוף ואת נקודת היעד. יש לבחון את
                רוחב הדרך, גובה המעברים, שערים, פניות,
                מכשולים ותנאי הגישה לאורך מסלול ההובלה.
              </p>

              <p>
                תכנון נכון מאפשר להתאים את אמצעי ההובלה
                ולבצע את העבודה בצורה מסודרת בהתאם
                למאפייני היחידה ולתנאים הקיימים במקום.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            הובלת מיגונית וממ"ד – תכנון נכון לפני העבודה
          </h2>


          <div className="bottom-text">

            <p>
              כל הובלה מתחילה בבדיקת תנאי השטח ובתכנון
              מסלול מתאים. כאשר מדובר במיגונית או ממ"ד,
              חשוב להתחשב במידות היחידה ובמשקל שלה ולוודא
              שהדרך מאפשרת מעבר מתאים אל היעד.
            </p>

            <p>
              בדיקה מוקדמת של מסלול ההובלה יכולה לסייע
              לזהות מגבלות ולתכנן את העבודה בצורה מסודרת.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              הובלת מיגוניות ניידות
            </h2>

            <p>
              מיגונית ניידת יכולה להידרש במגוון מקומות,
              ולכן לעיתים יש צורך להעביר אותה ממיקום
              אחד למיקום אחר. ההובלה דורשת התאמה של
              אמצעי ההובלה למידות ולמשקל המיגונית.
            </p>

            <p>
              נצר הובלות ומנופים מספקת פתרונות להובלת
              מיגוניות בהתאם למקום האיסוף, תנאי הדרך
              ונקודת היעד.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              הובלת ממ"ד נייד
            </h2>

            <p>
              גם הובלת ממ"ד נייד מחייבת תכנון מוקדם
              והתאמה לתנאי השטח. לפני תחילת העבודה
              יש לבדוק את מידות היחידה, המשקל שלה,
              אפשרויות הגישה והמיקום שבו היא אמורה
              להיות מוצבת.
            </p>

            <p>
              כאשר נדרש גם פתרון הרמה, יש לבחון מראש
              את תנאי האתר ולתכנן את שלבי ההרמה,
              ההובלה וההצבה.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              הובלת מיגוניות וממ"דים למרחקים שונים
            </h2>

            <p>
              ניתן לבצע הובלה של מיגוניות וממ"דים ניידים
              בתוך אותו יישוב, בין יישובים שונים או
              בין אזורים שונים בארץ.
            </p>

            <p>
              לכל הובלה נדרש להתאים את מסלול הנסיעה
              ואת אמצעי ההובלה בהתאם למידות היחידה,
              למרחק ולתנאי הדרך.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              הובלת מיגונית וממ"ד במקומות עם גישה מורכבת
            </h2>

            <p>
              לעיתים המיגונית או הממ"ד נמצאים בחצר,
              באתר בנייה, באזור צפוף או במקום שבו
              הגישה למשאית מורכבת.
            </p>

            <p>
              במקרים כאלה חשוב לבצע בדיקה מוקדמת של
              המקום ולתכנן את אופן ההגעה, ההובלה
              וההצבה בהתאם לתנאים בשטח.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              הצבת המיגונית או הממ"ד במקום היעד
            </h2>

            <p>
              לאחר הגעת היחידה אל היעד יש לבצע את
              שלב ההצבה בצורה מסודרת ובהתאם למיקום
              שנקבע מראש.
            </p>

            <p>
              כאשר נדרשת הצבה מדויקת או הרמה למקום
              מסוים, יש להתאים את פתרון ההרמה לתנאי
              האתר ולמאפייני היחידה.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להובלת מיגונית וממ"ד?
            </h2>

            <p>
              הובלת מיגונית או ממ"ד אינה הובלה רגילה.
              מדובר ביחידות בעלות משקל ומידות משמעותיים,
              ולכן חשוב לתכנן מראש את המסלול ואת אמצעי
              ההובלה המתאימים.
            </p>

            <p>
              תכנון נכון מאפשר לזהות מראש את תנאי הדרך,
              מגבלות הגישה ונקודת ההצבה ולבנות פתרון
              שמתאים לעבודה.
            </p>


            {/* =====================================================
                SECTION 8
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – הובלת מיגוניות וממ"דים
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי הובלה,
              הרמה ומנוף למגוון רחב של עבודות, כולל
              הובלת מיגוניות וממ"דים ניידים.
            </p>

            <p>
              צריכים להוביל מיגונית או ממ"ד נייד?
              צרו איתנו קשר, ספרו לנו על העבודה ונבחן
              עבורכם את פתרון ההובלה וההרמה המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Relocation_of_buildings"
              className="link-right"
            >
              העברת מבנים
            </Link>

            <Link
              to="/BuildingRehabilitation"
              className="link-left"
            >
              הובלת קרוואנים
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}